var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.36249C6.56667 5.36249 7.04792 5.16457 7.44375 4.76874C7.83958 4.3729 8.0375 3.89165 8.0375 3.32499V1.86249H3.9625V3.32499C3.9625 3.89165 4.16042 4.3729 4.55625 4.76874C4.95208 5.16457 5.43333 5.36249 6 5.36249ZM1.6875 11.3125V10.1375H2.7875V8.66686C2.7875 8.09728 2.93542 7.57499 3.23125 7.09999C3.52708 6.62499 3.925 6.25832 4.425 5.99999C3.925 5.73332 3.52708 5.36249 3.23125 4.88749C2.93542 4.41249 2.7875 3.8902 2.7875 3.32061V1.86249H1.6875V0.674988H10.325V1.86249H9.225V3.32061C9.225 3.8902 9.07708 4.41249 8.78125 4.88749C8.48542 5.36249 8.0875 5.73332 7.5875 5.99999C8.0875 6.25832 8.48542 6.62499 8.78125 7.09999C9.07708 7.57499 9.225 8.09728 9.225 8.66686V10.1375H10.325V11.3125H1.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.4abfd0a2a4496cd5c86eb4e3e3340623.svg";
export { ForwardRef as ReactComponent };